export const adaptParameterProfileResponse = (response) => {
  return {
    description: response?.description || '-',
    parameters: response?.parameters || [],
    name: response?.name || '-',
  };
};
